.Code {
  background-color: var(--color-background-code);
  color: var(--color-default);
  display: inline-block;
  white-space: pre-wrap;
  border-radius: 0.5rem;
  padding: 0.25rem 0.5rem;
  overflow-x: auto;
}

.LineNumber {
  color: var(--token-comment-color);
  border-right: 1px solid var(--color-panel-background);
  display: inline-block;
  margin-right: 1ch;
  padding-right: 1ch;
  min-width: calc(var(--max-line-number-length) + 1ch + 1px);
  user-select: none;
}
